class Global {
	constructor() {
		
		window.dataLayer = window.dataLayer || [];
		// -- hide logs -- //
            if( !document.body.classList.contains('display-logs') ) {
                console.log = function() {};
            }
        // -- END -- //

		window.theme.webp = false;
		this.checkWebp();
	}
	checkWebp() {
		var kTestImages = {
			lossy: "UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA",
			lossless: "UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==",
			alpha: "UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==",
			animation: "UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA"
		};
		var img = new Image();
		img.onload = function () {
			var result = (img.width > 0) && (img.height > 0);
			if( result ) {
				window.theme.webp = true;
			} else {
				window.theme.webp = false;
				resetLoadedImages();
			}
		};
		img.onerror = function () {
			window.theme.webp = false;
			resetLoadedImages();
		};
		img.src = "data:image/webp;base64," + kTestImages['lossy'];

		function resetLoadedImages() {
			document.querySelectorAll('.LazyAsset .wrapper__item--loaded').forEach( ( image, index ) => {			
				if( image.tagName.toLowerCase() == 'picture' && image.querySelector('source').hasAttribute('data-srcset-basic') && window.theme.webp == false ) { 
					// set into source srcset jpg image
					image.querySelector('source').setAttribute('srcset', image.querySelector('source').getAttribute('data-srcset-basic') );
				}
				image.querySelector('source').removeAttribute('data-srcset-basic');
			});
		}

	}
	loadScript( src = null ) {
		let script = null;
		if( src ) {
			script = document.querySelector('script[src="'+src+'"]');
			if( !script ) {
				script = document.createElement('script');
				script.src = src;
				script.async = 1;
				document.body.insertAdjacentElement( 'beforeend', script );
				console.log( 'Script load : ' + src );
			}
		}
		return script;
	}
    checkCookie( cname ){
		var name = cname + "=";
	    var decodedCookie = decodeURIComponent(document.cookie);
	    var ca = decodedCookie.split(';');
	    for(var i = 0; i < ca.length; i++) {
	        var c = ca[i];
	        while (c.charAt(0) == ' ') {
	            c = c.substring(1);
	        }
	        if (c.indexOf(name) == 0) {
	            return c.substring(name.length, c.length);
	        }
	    }
	    return "";
	}
	setCookie( cname, cvalue, exdays = 7 ) {
		var d = new Date();
	    d.setTime(d.getTime() + (exdays*24*60*60*1000));
	    var expires = "expires="+ d.toUTCString();
	    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}
	loadPopup( popupID = null, time = null ) {
		let t = this;
		let data = {};
		let cookieName = 'popup-'+popupID;
		if( time ) {
			cookieName += '-'+time;
		}
		if( t.checkCookie( cookieName ) != '1' ) {

			data = {};
			data['id'] = popupID;
			data['node'] = document.createElement('div');
			data['styles'] = null;
			data['scripts'] = null;
			data['scriptsCount'] = 0;
			data['element'] = null;
			data['scriptsObj'] = {};
			let uniq = null;

			fetch( window.location.origin+'/cpt_popup/?popup_id='+popupID, {
				method: 'GET'
			})
			.then( ( response ) => {
				return response.text();
			})
			.then( ( html ) => {

				data['node'].innerHTML = html;
				data['element'] = data['node'].querySelector('.PopupSection');
				data['styles'] = [];
				data['scripts'] = [];

				data['node'].querySelectorAll('link[rel="stylesheet"]').forEach( ( style, index ) => {
					if( !document.querySelector('link[href="'+style.getAttribute('href')+'"]') ) {
						data['styles'].push( style.getAttribute('href') ); // info which style was loaded
						document.body.appendChild( style );
					}
				});
				document.body.insertAdjacentElement( 'beforeend', data['node'].querySelector('.PopupSection') );
				data['element'] = document.querySelector('.PopupSection');


				data['node'].querySelectorAll('script[src]').forEach( ( script, index ) => {
					if( !document.querySelector('script[src="'+script.getAttribute('src')+'"]') ) {
						data['scripts'].push( script.getAttribute('src') ); // info which script was loaded

						let element = document.createElement('script');
						element.src = script.getAttribute('src');
						if( script.hasAttribute('data-class') ) {
							element.setAttribute('data-class', script.getAttribute('data-class') );
						}
						document.body.appendChild( element );

						element.addEventListener( 'load', () => {

							data['scriptsCount'] += 1;

							if( data['scriptsCount'] == data['scripts'].length ) {
								data['element'].querySelectorAll('[data-jsmodule]').forEach( ( obj, index ) => {
									if( typeof JSModules[ obj.getAttribute('data-jsmodule') ] != undefined && JSModules[ obj.getAttribute('data-jsmodule') ] ) {
										uniq = Math.random().toString(16).slice(2);
										data['scriptsObj'][uniq] = new JSModules[ obj.getAttribute('data-jsmodule') ]( obj );
										data['scriptsObj'][uniq].init();
									}
								});

								uniq = Math.random().toString(16).slice(2);
								data['scriptsObj'][uniq] = new JSModules['PopupSection']( data['element'] );
								data['scriptsObj'][uniq].init();

								window.theme.lazyObj.init();

							}

						});
					}
				});

				console.log( data );
				
			})
			.catch( ( message ) => {
				console.error( message );
			});
		} else {
			console.log( 'Popup cookie exist ('+popupID+')' );
		}
	}

}
export default Global;